import { ImageCropperService } from './image-cropper.service';

export default angular
  .module('sfMobile.services.image-cropper', [])
  .service('imageCropperService', ImageCropperService).name;
